import { TextTiny } from 'base/ui/typography';
import React from 'react';
import styles from './bespoke_pill.css';

export function BespokePill({ label }: { label: string }) {
  return (
    <span className={styles.bespokePill}>
      <TextTiny>{label}</TextTiny>
    </span>
  );
}
